import BreadCrumb from "../../../Components/Common/BreadCrumb";
import { useParams, Link } from "react-router-dom";
import {
  Button,
  Table,
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Spinner,
} from "reactstrap";
import React, { useState, useEffect } from "react";
import PrintHeader from "../../../Components/PrintHeader/PrintHeader";
import { formatDate } from "../../../Components/FormatDate/FormatDate";
import PurchasesServices from "../../../Services/Inventory Services/PurchasesServices";
import NumberCommas from "../../../Components/NumberCommas/NumberCommas";

const PurchaseDisplay = () => {
  const { id } = useParams();
  const [purchaseDetail, setPurchaseDetail] = useState(null);
  console.log("🚀 ~ PurchaseDisplay ~ purchaseDetail:", purchaseDetail);
  const [loading, setLoading] = useState(true);

  const viewItem = async (itemId) => {
    try {
      const fetchedItem = await PurchasesServices.view(itemId);
      setPurchaseDetail(fetchedItem);
    } catch (error) {
      console.error("Error viewing item:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    viewItem(id);
  }, [id]);

  if (loading) {
    return (
      <div className="page-content">
        <Container fluid className="text-center py-5">
          <Spinner color="primary" />
          <p className="mt-2">Loading purchase details...</p>
        </Container>
      </div>
    );
  }

  return (
    <div className="page-content">
      <Container fluid>
        <BreadCrumb
          title="Purchase Details"
          pageTitle="Purchase"
          breadcrumbItems={[{ title: "Back To List ", link: "/purchase" }]}
        />
        <Card className="shadow-sm">
          <PrintHeader reportTitle="Purchase Invoice" />
          <CardBody>
            <div className="d-flex justify-content-between align-items-center mb-4 d-print-none">
              <h4 className="card-title mb-0 d-print-none">Purchase Invoice</h4>
              <Button
                color="outline-secondary"
                className="py-2 px-3 d-flex align-items-center shadow-sm d-print-none"
                onClick={() => window.print()}
              >
                <i className="ri-printer-line fs-16"></i>
              </Button>
            </div>

            <Row>
              <Col xs={12} sm={6} md={6}>
                <Row className="mb-4">
                  <Col>
                    <div className="d-flex flex-column">
                      <div className="d-flex align-items-center">
                        <Link
                          to={`/vendor/viewdetails/${purchaseDetail?.vendorData?.id}`}
                          className="text-primary d-flex align-items-center"
                        >
                          {purchaseDetail?.vendorData?.name}
                        </Link>
                      </div>
                      {purchaseDetail?.vendorData?.address && (
                        <div className="d-flex align-items-center">
                          <span className="text-capitalize">
                            {purchaseDetail?.vendorData?.address}
                          </span>
                          , <span>{purchaseDetail?.vendorData?.tel_No}</span>
                        </div>
                      )}
                      {purchaseDetail?.vendorData?.registration_No && (
                        <div className="d-flex align-items-center">
                          <label className="text-muted me-2 mb-0">
                            PAN/VAT No:
                          </label>
                          <span>
                            {purchaseDetail?.vendorData?.registration_No}
                          </span>
                        </div>
                      )}
                      {purchaseDetail?.vendorData?.registered_Date && (
                        <div className="d-flex align-items-center">
                          <label className="text-muted me-2 mb-0">
                            Registered Date:
                          </label>
                          <span>
                            {formatDate(
                              purchaseDetail.vendorData.registered_Date
                            )}
                          </span>
                        </div>
                      )}
                    </div>
                  </Col>
                </Row>
              </Col>
              <Col xs={12} sm={6} md={6}>
                <Row className="mb-4">
                  <Col xs="12" className="d-flex flex-column align-items-end">
                    <div className="d-flex align-items-center">
                      <label className="text-muted mb-0 me-2">
                        Invoice No:
                      </label>
                      <span>{purchaseDetail?.invoiceNumber}</span>
                    </div>
                    <div className="d-flex align-items-center mb-2">
                      <label className="text-muted me-2 mb-0">Date:</label>
                      <span>{formatDate(purchaseDetail?.valueData)}</span>
                    </div>
                  </Col>
                </Row>
              </Col>
            </Row>

            <div className="table-responsive mb-4">
              <Table hover bordered>
                <thead className="table-light">
                  <tr>
                    <th style={{ width: "60px" }}>S.N</th>
                    <th>Product</th>
                    <th>Mfg. Date</th>
                    <th>Exp.Date</th>
                    <th>Batch No.</th>
                    <th style={{ width: "150px" }}>Quantity</th>
                    <th style={{ width: "140px" }}>Purchase Rate</th>
                    <th style={{ width: "140px" }}>Total Amount</th>
                  </tr>
                </thead>
                <tbody>
                  {purchaseDetail?.purchaseItems?.map((item, index) => (
                    <tr key={item.id}>
                      <td>{index + 1}</td>
                      <td>
                        <Link
                          to={`/product/details/${item.productID}`}
                          className="text-primary"
                        >
                          {item.itemName}
                        </Link>
                      </td>
                      <td>{formatDate(item.mfgDate || "N/A")}</td>
                      <td>{formatDate(item.expDate || "N/A")}</td>
                      <td>{item.batchNo || "N/A"}</td>
                      <td className="text-end">{item.quantity}</td>

                      <td className="text-end">
                        <NumberCommas number={item.purchaseRate} />
                      </td>
                      <td className="text-end">
                        <NumberCommas number={item.amount} />
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            </div>

            <Row className="justify-content-end">
              <Col xs={8} sm={8} md={8} lg={9}>
                <div className="d-flex align-items-center mb-2">
                  <label className="text-muted me-2 mb-0">
                    Amount In Words:
                  </label>
                  <p className="mb-0 fw-medium">
                    {purchaseDetail?.net_Amt_Words}
                  </p>
                </div>
                <div className="d-flex align-items-center">
                  <label className="text-muted mb-0 me-2">Remarks:</label>
                  <p className="mb-0">{purchaseDetail?.remarks || "N/A"}</p>
                </div>
              </Col>

              <Col xs={4} sm={4} md={4} lg={3}>
                <div className="d-flex justify-content-between mb-2">
                  <span>Sub Total:</span>
                  <span className="text-end">
                    <NumberCommas number={purchaseDetail?.subTotal} />
                  </span>
                </div>

                <div className="d-flex justify-content-between ">
                  <span>Total:</span>
                  <span className="text-end">
                    <NumberCommas number={purchaseDetail?.total} />
                  </span>
                </div>
                <hr />
                <div className="d-flex justify-content-between fw-bold mt-3">
                  <span>Net Amount:</span>
                  <span className="text-end">
                    <NumberCommas number={purchaseDetail?.total} />
                  </span>
                </div>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </Container>
    </div>
  );
};

export default PurchaseDisplay;
